export default function unmarkDuplicates(way, mapping, additionalMapping) {
    mapping.forEachObject((value, key) => {
        this.dsAdd('set', way + '/table/header/mapping/duplicates/' + key, false);
    })

    additionalMapping.forEach((value, key) => {
        this.dsAdd('set', way + '/additionalData/' + key + '/duplicate', false);
    })
}